import { useLocalStorage } from '@distribute/frontend/utils';
import { CALL_RECORDING_VIEW } from '../../../shared/constants';
import { SwitchGridListValue } from '../../../shared/ui';

export const useCallsView = () => {
  const [view, setView] = useLocalStorage<SwitchGridListValue>(
    CALL_RECORDING_VIEW,
    'grid'
  );

  return { view, setView };
};
